import React from 'react';
import { Stack, Typography } from '@mui/material';

interface Props {
  paymentType: string;
  applyingFor: string;
  equipmentCondition: string;
}

const formatRuleValue = (value: string) =>
  value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[-_]/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const ApplyRulesCell = ({ paymentType, applyingFor, equipmentCondition }: Props) => {
  const lines: Array<{ label: string; value: string }> = [];

  if (paymentType) lines.push({ label: 'Payment Type', value: formatRuleValue(paymentType) });
  if (applyingFor) lines.push({ label: 'Applying For', value: formatRuleValue(applyingFor) });
  if (equipmentCondition) lines.push({ label: 'Equipment Condition', value: formatRuleValue(equipmentCondition) });

  if (!lines.length) return <Typography color="text.secondary">—</Typography>;

  return (
    <Stack>
      {lines.map(({ label, value }) => (
        <Typography key={label} variant="body2">
          <Typography component="span" variant="body2" color="text.secondary">
            {label}:
          </Typography>{' '}
          {value}
        </Typography>
      ))}
    </Stack>
  );
};
